




































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import InfiniteLoading, { StateChanger } from "vue-infinite-loading";
import AbcButton from "../button/AbcButton.vue";
import AbcNoDataFound from "../alert/AbcNoDataFound.vue";
import AbcLoader from "../loader/AbcLoader.vue";

export type DataProvider = () => Promise<boolean>;

@Component({
    components: {
        InfiniteLoading,
        AbcNoDataFound,
        AbcButton,
        AbcLoader,
    },
})
export default class AbcInfiniteSupport extends Vue {
    @Prop() dataProvider!: DataProvider;
    @Prop({ default: 1 }) identifier!: number;
    @Prop({ default: 1 }) manualIdentifier!: number;
    @Prop({ type: Boolean }) hideNoMore!: boolean;
    @Prop({ type: Boolean }) hideError!: boolean;
    @Prop({ type: Boolean }) hideNoResults!: boolean;
    @Prop({ type: Boolean }) hideSpinner!: boolean;

    async infiniteHandler(stateChanger: StateChanger) {
        try {
            const loadAgain = await this.dataProvider();
            if (loadAgain) {
                stateChanger.loaded();
            } else {
                stateChanger.complete();
            }
        } catch (e) {
            stateChanger.error();
        }
    }

    @Watch("manualIdentifier")
    private onManualIdentifierUpdate() {
        (this.$refs.infiniteLoading as any).status = 1;
        (this.$refs.infiniteLoading as any).$emit("infinite", (this.$refs.infiniteLoading as any).stateChanger);
    }
}
